import { ROLE_ID, ROLE_PRIORITY } from '@/config/constants';
import { PERMISSIONS } from '@/config/permissions';
import { _p } from '../../utils/model-proto';
import BaseModel from '..';
import Role from './role';
import Permissions from './permissions';
import NoteGroups from '../master/noteGroups';

const { MANAGER, ADMIN } = ROLE_ID;
const ADMIN_ID = [MANAGER, ADMIN];

class User extends BaseModel {
  static properties = {
    id: null,
    username: null,
    displayName: null,
    email: null,
    role: _p(Role, new Role()),
    token: null,
    noteGroups: _p(NoteGroups, new NoteGroups()),
    permissions: _p(Permissions, new Permissions()),
    hasPermission: null,
  };

  // eslint-disable-next-line no-useless-constructor
  constructor(obj) {
    super(obj);
  }

  /*
  username: string;
  name: string;
  email: string;
  role: Role;
  token: string;
  */

  get isAuthenticated() {
    return !!this.token;
  }
  
  get canInsertProvinceKeyword() {
    return this.permissions.can(PERMISSIONS.INSERT_PROVINCE_KEYWORD);
  }

  get canDeleteProvinceKeyword() {
    return this.permissions.can(PERMISSIONS.DELETE_PROVINCE_KEYWORD);
  }

  get canImportQtProduct() {
    return this.permissions.can(PERMISSIONS.IMPORT_QT_PRODUCT);
  }

  get canViewQtExpense() {
    return this.permissions.can(PERMISSIONS.VIEW_QT_EXPENSE);
  }

  get isAdmin() {
    return ADMIN_ID.some((id) => this.role?.id === id);
  }

  get isManager() {
    return MANAGER === this.role?.id;
  }

  isRole(role) {
    if (!this.role) return false;

    return this.role.type === role;
  }

  /**
   * 
   * @param {'admin' | 'manager' | 'staff' | 'marketter'} role
   * @returns boolean
   */
  hasPriorityRole(role) {
    if (this.role.type === role) return true;

    const userPriority = ROLE_PRIORITY[this.role.type];
    const rolePriority = ROLE_PRIORITY[role] || -1;

    return userPriority < rolePriority;
  }

  withPermission(permission) {
    if (this.isAdmin || this.isManager) return true;
    return this.permissions.can(permission);
  }
}

export default User;
